<template>
  <div class="mm-page-main">
    <div v-show="!isdetail">
      <div class="page-header">
        <div class="page-title">銀行賬戶記錄</div>

      </div>
      <search :form="form" @submit="getbanklogs"></search>
      <div style="height: 20px;">
      </div>
      <div class="pagetablebox">
        <el-table v-loading="loading" empty-text="暫無數據" :data="data" border :header-cell-style="{background:'#FAFAFA'}">
          <el-table-column prop="code" label="賬戶代號" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">賬戶代號</div>
              <span>{{scope.row.code}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="銀行賬戶" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">銀行賬戶</div>
              <div class="mm-text-right">
                <div>
                  <img style="width: 16px; height: 16px;margin-right:10px;" :src="apiurl+scope.row.thumb">
                  <span>{{scope.row.short_name}}</span>
                </div>
                <div style="padding:5px;">{{scope.row.bankinfo!=''?scope.row.bankinfo:scope.row.bankname}}</div>
                <div style="padding:5px;">{{scope.row.account_name}}</div>
                <div style="padding:5px;">{{addSpace(scope.row.account_num)}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="addtime" label="日期" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">日期</div>
              <span>{{scope.row.addtime}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="income" label="收入" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">收入</div>
              <span v-if="scope.row.income>0" class="textblue">{{tomoney(scope.row.income)}}</span>
            </template>
          </el-table-column>
          </el-table-column>
          <el-table-column prop="pay" label="支出" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">支出</div>
              <span v-if="scope.row.pay>0" class="textred">{{tomoney(scope.row.pay)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="surplus" v-if="customer_id==0" label="結餘" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">結餘</div>
              <div>{{tomoney(scope.row.surplus)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="customer_surplus" v-if="customer_id>0" label="結餘" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">結餘</div>
              <div>{{tomoney(scope.row.customer_surplus)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="關聯交易單號" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">關聯交易單號</div>
              <el-link type="primary" v-if="scope.row.buytype == 0" @click="buydetails(scope.row.business_id)">B{{scope.row.businessnum}}</el-link>
              <el-link type="primary" v-else-if="scope.row.buytype == 1" @click="selldetails(scope.row.business_id)">S{{scope.row.businessnum}}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="關聯訂單號" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">關聯訂單號</div>
              <el-link @click="orderdetails(scope.row.order_id)" type="primary">
                <span v-if="scope.row.ordertype == 0">{{scope.row.store_short}}-C{{scope.row.ordernum}}</span>
                <span v-else-if="scope.row.ordertype == 1">{{scope.row.store_short}}-R{{scope.row.ordernum}}</span>
                <span v-else-if="scope.row.ordertype == 2">{{scope.row.store_short}}-I{{scope.row.ordernum}}</span>
              </el-link>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="page-bottom">
        <div>
        </div>
        <div>
          <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
          </el-pagination>
        </div>
        <div>
          Total: {{pager.p_count}} 條記錄
        </div>
      </div>
    </div>
    <div v-if="isdetail">
      <buybuinessdetails v-if="buinesstype==0" :visible.sync="isdetail" @refresh="getbanklogs" :id="buineessid"></buybuinessdetails>
      <sellbuinessdetails v-if="buinesstype==1" :visible.sync="isdetail" @refresh="getbanklogs" :id="buineessid"></sellbuinessdetails>
    </div>
  </div>
</template>

<script>
import search from "./components/SearchLog.vue";
import buybuinessdetails from "@/components/BuyBusinessDetails.vue";
import sellbuinessdetails from "@/components/SellBusinessDetails.vue";
export default {
  components: {
    search,
    buybuinessdetails,
    sellbuinessdetails
  },
  props:{
    customer_id:{
      type:Number,
      default:0,
    }
  },
  data () {
    return {
      buineessid:0,
      isdetail:false,
      buinesstype: 0,
      loading: true,
      is_init: true,
      store_id: 0,
      stores: [],
      form: {
        currency: [],
        record_type: "-1",
        currency_id: "-1",
        starttime: '',
        endtime: '',
        sortname:'addtime',
        orderby:'DESC',
      },
      data: [],
      page: 1,
      pagesize: 10,
      pager: []
    }
  },
  methods: {
    edit (row) {
      this.$router.push({
        name: '/EditCashAccount',
        path: '/EditCashAccount',
        params: {
          row: row
        }
      })
    },
    buydetails (id) {
      this.buineessid = id;
      this.buinesstype = 0;
      this.isdetail = true;
      // this.$router.push({
      //   name: '/BuyBusinessDetails',
      //   path: '/BuyBusinessDetails',
      //   params: {
      //     id: id
      //   }
      // })
    },
    selldetails (id) {
      this.buineessid = id;
      this.buinesstype = 1;
      this.isdetail = true;
      // this.$router.push({
      //   name: '/SellBusinessDetails',
      //   path: '/SellBusinessDetails',
      //   params: {
      //     id: id
      //   }
      // })
    },
    orderdetails (id) {
      this.$router.push({
        name: '/OrderDetails',
        path: '/OrderDetails',
        query: {
          id: id
        }
      })
    },
    async getCurrency () {
      // 获取货币
      await this.post('/api/bank/getcurrency', {})
        .then(response => {
          let currency = this.form.currency = response;
          // 默认 设置
          // if (this.is_init) {
          //   currency.some(item => {
          //     if (item.short_name == 'HKD') {
          //       this.form.currency_id = item.id;
          //     }
          //   })
          //   this.is_init = false;
          // }

        }).catch(error => {
          console.log(error);
        })
    },
    getbanklogs () {
      this.data = [];
      this.loading = true;
      let form = this.form;
      this.post('/api/bank/getbanklogs', {
        customer_id:this.customer_id,
        store_id: this.store_id,
        page: this.page,
        pagesize: this.pagesize,
        currency_id: form.currency_id,
        record_type: form.record_type,
        starttime: form.starttime,
        endtime: form.endtime,
        startamount: form.startamount,
        endamount: form.endamount,
        bankname: form.bankname,
        account_num: form.acount_num,
        code:form.code,
        sortname:form.sortname,
        orderby:form.orderby,
      }).then((res) => {
        if (res.info.length > 0) {
          this.data = res.info;
          this.pager = res.pager;
          this.page = 1;
        } else {
          this.data = [];
          this.pager = [];
        }
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      }).then(() => {

      })
    },

    changeordertype () {
      this.getbanklogs();
    },
    changepage (val) {
      this.page = val;
      this.getbanklogs();
    },
    changesize (val) {
      this.pagesize = val;
      this.getbanklogs();
    },

    changestore (store_id) {
      this.store_id = store_id;
      this.getbanklogs();

    },

    gotoruter (name) {
      this.$router.push(name)
    },

  },
  async created () {
    await this.getCurrency(); // 獲取貨幣
    this.getbanklogs(); // 獲取記錄
  },
  watch: {
    'form': { // 動態監控利率變化
      handler: function (val) {
        // console.log(val);
        this.getbanklogs();
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.pagetablebox {
  padding: 20px 0;
}
.textred {
  color: red;
}
.textblue {
  color: blue;
}
</style>
